import { Button, Field, Flex, Input, Text } from "@chakra-ui/react";
import DropDown from "components/DropDown";
import { Header } from "components/Header";
import TableList from "components/TableList";
import { useState } from "react";

const headers = ["Covered Items"];

const items = [
  {
    id: 1,
    coveredItems: "30 Day Admin",
  },
];

function CoveredParts() {
  const [isLoading, setIsLoading] = useState(false);

  const onNew = () => {
    setIsLoading(false);
  };

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Covered Parts"} isLoading={isLoading} />

      <Flex justifyContent="space-between" gap={"3"}>
        <Flex flexFlow={"wrap"} gap={"0.5rem"} alignItems={"center"}>
          {/* <Field.Root orientation="vertical" w={"22rem"}>
              <Field.Label textStyle={"md"}>Account</Field.Label>
              <DropDown />
            </Field.Root> */}

          <Field.Root orientation="vertical" w={"22rem"}>
            <Input placeholder="Search" textStyle={"md"} />
          </Field.Root>
          <DropDown />
        </Flex>
      </Flex>
      <Flex flexDirection={"column"} flex={1}>
        <TableList headers={headers} items={items} />
      </Flex>
      <Flex flexFlow={"wrap"} gap={"0.5rem"} mt={"2rem"}>
        <Flex flex={1}>
          <Text fontWeight={"medium"} textStyle={"md"}>
            Part Covered
          </Text>
          <Input textStyle={"md"} />
        </Flex>
        <Button variant="outline" onClick={onNew}>
          Add
        </Button>
        <Button variant="outline" onClick={onNew}>
          Remove
        </Button>
        <Button w={"12rem"} bg={"primary"} onClick={onNew}>
          Save
        </Button>
      </Flex>
    </Flex>
  );
}

export default CoveredParts;
